import { Container } from "../shared/components/layout/container.js";
import { ErrorDialog } from "../shared/components/feedback/error-dialog.js";
import { Poster } from "../shared/components/layout/poster.js";
import { LiveVideoGestures } from "../shared/skins/shared/live-video/gestures.js";
import { LiveVideoHotkeys } from "../shared/skins/shared/live-video/hotkeys.js";
import { BufferingIndicator } from "./components/feedback/buffering-indicator.js";
import { MinimalLiveVideoControls } from "./controls.js";
import { LiveVideoStatusIndicators } from "./skins/shared/live-video/status-indicators.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/minimal-live-video/skin.tsx
/** @jsxImportSource react */
function MinimalLiveVideoSkin({ children, className, renderPoster, ...props } = {}) {
	return /* @__PURE__ */ jsxs(Container, {
		className: cn("video-skin", className),
		"data-theme": "minimal",
		"data-preset": "live-video",
		...props,
		children: [
			children,
			/* @__PURE__ */ jsx(Poster, { renderImage: renderPoster }),
			/* @__PURE__ */ jsx(BufferingIndicator, {}),
			/* @__PURE__ */ jsx(ErrorDialog, {}),
			/* @__PURE__ */ jsx(MinimalLiveVideoControls, {}),
			/* @__PURE__ */ jsx(LiveVideoHotkeys, {}),
			/* @__PURE__ */ jsx(LiveVideoGestures, {}),
			/* @__PURE__ */ jsx(LiveVideoStatusIndicators, {})
		]
	});
}
//#endregion
export { MinimalLiveVideoSkin };

//# sourceMappingURL=skin.js.map